import { createSlice } from "@reduxjs/toolkit";

const initialDailyAttendanceReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  sections: [],
  students: [],
  advisors: [],
  teachers: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const dailyAttendanceReportSlice = createSlice({
  name: "dailyAttendanceReport",
  initialState: initialDailyAttendanceReportState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getDailyAttendanceReport
    dailyAttendanceReportFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getAllList
    allListFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entity.sections;
      state.advisors = entity.advisorList;
      state.teachers = entity.teachers;
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.students = entity.students;
      state.advisors = entity.advisorList;
      state.teachers = entity.teachers;
    },
    // getAdvisorsAndTeachers
    advisorsAndTeachersFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.advisors = entity.advisorList;
      state.teachers = entity.teachers;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.students = entities;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanStudentsState
    studentsStateCleaned: (state) => {
      state.students = [];
    },
    // cleanDailyAttendanceReportState
    dailyAttendanceReportStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
    }
  }
});